module.exports = __webpack_public_path__ + "img/monitor-waveform.6c18fb5f.svg";